import { userPreferences } from '#packages/stateManagement';
import _ from 'lodash';

import type {
  Dispatch,
  MapDispatchToPropsFunction,
  MapStateToProps,
} from 'types/redux';
import type {
  AiAssistantDispatchProps,
  AiAssistantOwnProps,
  AiAssistantStateProps,
} from './aiAssistantTypes';
export const IS_FIRST_ASSISTANT_MESSAGE = 'IS_FIRST_ASSISTANT_MESSAGE';

export const mapStateToProps: MapStateToProps<
  AiAssistantStateProps,
  AiAssistantOwnProps
> = ({ state }) => {
  const isFirstMessage: boolean = _.defaultTo(
    userPreferences.selectors.getSessionUserPreferences(
      IS_FIRST_ASSISTANT_MESSAGE,
    )(state),
    true,
  );

  return { isFirstMessage };
};

export const mapDispatchToProps: MapDispatchToPropsFunction<
  AiAssistantDispatchProps,
  AiAssistantOwnProps
> = (dispatch: Dispatch) => {
  const setToUserPreferences = (key: string, value: boolean) => {
    dispatch(userPreferences.actions.setSessionUserPreferences(key, value));
  };

  return { setToUserPreferences };
};
